<script lang="ts">
	interface Props {
		title: string;
		children?: import('svelte').Snippet;
	}

	const { title, children }: Props = $props();
</script>

<div>
	<div class="text-lg mb-2">{title}</div>
	{@render children?.()}
</div>
